import { type FC, useEffect, useState } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { type CuiOptionType, Dropdown } from '@crehana/ui';
import { useRouter } from 'next/router';

import useTeamLeader from './hooks/useTeamLeader';

interface TeamSelectProps {
  isDark?: boolean;
}

export const TeamSelect: FC<TeamSelectProps> = ({ isDark }) => {
  const { push } = useRouter();
  const { teams, currentTeam, slug } = useTeamLeader();

  const [teamSelected, setTeamSelected] = useState<CuiOptionType<string>>();

  useEffect(() => {
    if (currentTeam) {
      setTeamSelected({
        label: String(currentTeam.name),
        value: String(currentTeam.originalId),
      });
    }
  }, [currentTeam]);

  const onSelect = (team: CuiOptionType<string> | undefined) => {
    team && setTeamSelected(team);
    push(`/org/${slug}/panel/lider/${team?.value}/estadisticas/general/`);
  };

  const teamOptions = teams.map(t => ({
    label: String(t.name),
    value: String(t.originalId),
  }));

  return (
    // TODO: talk with the code owner to fix this code so we can enable this rule again
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div onClick={e => e.preventDefault()} className="w-full p-16 pb-0">
      <Dropdown
        isDark={isDark}
        className="sm:w-full"
        options={teamOptions}
        onSelected={onSelect}
        selected={teamSelected}
      />
    </div>
  );
};

export default TeamSelect;
